var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoNatureMutation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.416,
    height: 22.149,
    viewBox: "0 0 15.416 22.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6",
    transform: "translate(0 12.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_388",
    "data-name": "Trac\\xE9 388",
    d: "M15.12,72.723H.456a.366.366,0,0,1,0-.733H15.12a.366.366,0,0,1,0,.733Z",
    transform: "translate(-0.07 -69.811)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_389",
    "data-name": "Trac\\xE9 389",
    d: "M15.032,95.683H.366a.366.366,0,1,1,0-.733H15.032a.366.366,0,1,1,0,.733Z",
    transform: "translate(0 -88.64)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_390",
    "data-name": "Trac\\xE9 390",
    d: "M2.648,67.35a.36.36,0,0,1-.257-.109l-2.2-2.2a.349.349,0,0,1-.016-.5l.016-.018,2.2-2.2a.364.364,0,0,1,.514.514L.969,64.783,2.9,66.727a.351.351,0,0,1,.016.5l-.016.018A.358.358,0,0,1,2.648,67.35Z",
    transform: "translate(-0.062 -62.237)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_391",
    "data-name": "Trac\\xE9 391",
    d: "M56.231,90.3a.34.34,0,0,1-.257-.109.353.353,0,0,1-.016-.5l.016-.016L57.9,87.735,55.97,85.791a.364.364,0,0,1,.514-.514h0l2.2,2.2a.351.351,0,0,1,.016.5.1.1,0,0,1-.016.016l-2.2,2.2a.344.344,0,0,1-.257.109Z",
    transform: "translate(-43.38 -81.059)",
    fill: "#616a7d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_382",
    "data-name": "Trac\\xE9 382",
    d: "M15.759,6.343c-.393-.38-.8-.758-1.2-1.117l-.279-.268A.411.411,0,0,0,14,4.833a.3.3,0,0,0-.223.112.331.331,0,0,0,0,.447l.04.031.478.447.422.389c.192.183.38.353.568.536a.311.311,0,0,1,.107.2.328.328,0,0,1-.282.364.4.4,0,0,1-.333-.152L8.91,1.731c-.223-.223-.371-.223-.594,0L3.077,6.647c-.237.223-.447.447-.711.67a.328.328,0,0,1-.382.042.3.3,0,0,1-.147-.349.644.644,0,0,1,.172-.261L8.3.819c.223-.206.364-.206.572,0l3.224,3,.127.121.371.344a.342.342,0,0,0,.478,0,.369.369,0,0,0,.092-.241.32.32,0,0,0-.107-.223c0-.025-.045-.045-.063-.067L9.354.332a1,1,0,0,0-1.4-.08l-.1.08L6.228,1.881,5.989,2.1V2.062c0-.447-.172-.617-.61-.617H4.143c-.447,0-.6.181-.6.606V4.2a.447.447,0,0,1-.161.364c-.637.585-1.274,1.182-1.9,1.788l-.045.04a.992.992,0,0,0,.7,1.687h0a.981.981,0,0,0,.693-.286L3.35,7.3l.134-.125v3.575c0,.4-.121.939.165,1.263s.863.259,1.283.259h6.239c.69,0,1.83.208,2.29-.422a1.768,1.768,0,0,0,.264-1.1v-3.6h0l.223.206c.139.134.282.268.447.4a.979.979,0,0,0,.7.264,1,1,0,0,0,.7-.326.981.981,0,0,0-.063-1.381ZM5.325,2.12v.59a.15.15,0,0,1-.034.074l-1.082,1V2.12Zm4.391,9.5H7.524V7.729H9.716Zm.67,0V7.693c0-.474-.188-.657-.657-.657H7.5a.547.547,0,0,0-.626.447.434.434,0,0,0,0,.152v3.986H4.858c-.223,0-.5.049-.637-.17a2.235,2.235,0,0,1-.063-1.028V6.638a.255.255,0,0,1,.085-.156l4.322-4.1.049-.04.362.337.67.617c1.1,1.037,2.235,2.087,3.352,3.128a.266.266,0,0,1,.092.223c-.045.751,0,1.52,0,2.268v1.242a2.681,2.681,0,0,1-.085,1.117.507.507,0,0,1-.273.264,2.556,2.556,0,0,1-.737.04Z",
    transform: "translate(-0.892 -0.002)",
    fill: "#616a7d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoNatureMutation);
export default __webpack_public_path__ + "static/media/picto_nature_mutation.bdbf6fa6.svg";
export { ForwardRef as ReactComponent };